import React from 'react';
import { Swords } from 'lucide-react';
import SwissCompetitionView from './SwissCompetitionView';
import LeagueCompetitionView from './LeagueCompetitionView';
import GroupsCompetitionView from './GroupsCompetitionView';
import KnockoutBracketView from './KnockoutBracketView';
import { pickLocalizedText } from '../../../utils/localizedContent';

export default function CompetitionRenderer(props) {
  const { event, bracket, hasEventsPermission, participants, onGenerateBracket, onStartSwiss, onNextSwissRound, onAdvanceGroups, onSelectMatch, actionLoading, lang } = props;
  const format = bracket?.format || event?.tournament_type || 'swiss';
  const text = (es, en) => pickLocalizedText(lang, es, en);

  const participantsById = Object.fromEntries(
    (participants?.participants || participants?.deployed || participants || [])
      .filter((p) => p && p.user_id)
      .map((p) => [p.user_id, p]),
  );

  if (!bracket) {
    return (
      <div className="text-center py-12">
        <Swords size={40} className="mx-auto text-[#A8B5AE]/30 mb-3" />
        <p className="text-[#A8B5AE]">{text('La competicion aun no ha sido iniciada', 'Competition has not started yet')}</p>
        {hasEventsPermission && participants?.total_checked_in >= 2 && (
          <>
            {format === 'swiss' ? (
              <button onClick={onStartSwiss} disabled={actionLoading === 'swiss-start'} className="btn-primary px-6 py-2 text-sm mt-4">
                {text('Iniciar torneo suizo', 'Start Swiss Tournament')}
              </button>
            ) : (
              <button onClick={onGenerateBracket} disabled={actionLoading === 'bracket'} className="btn-primary px-6 py-2 text-sm mt-4">
                {text('Iniciar competicion', 'Start competition')}
              </button>
            )}
          </>
        )}
      </div>
    );
  }

  if (format === 'swiss') {
    return (
      <SwissCompetitionView
        bracket={bracket}
        hasEventsPermission={hasEventsPermission}
        onSelectMatch={onSelectMatch}
        onNextSwissRound={onNextSwissRound}
        actionLoading={actionLoading}
        lang={lang}
        participantsById={participantsById}
      />
    );
  }
  if (format === 'league') {
    return (
      <LeagueCompetitionView
        bracket={bracket}
        hasEventsPermission={hasEventsPermission}
        onSelectMatch={onSelectMatch}
        lang={lang}
        participantsById={participantsById}
      />
    );
  }
  if (format === 'groups_elimination') {
    return (
      <GroupsCompetitionView
        bracket={bracket}
        hasEventsPermission={hasEventsPermission}
        onSelectMatch={onSelectMatch}
        onAdvanceGroups={onAdvanceGroups}
        actionLoading={actionLoading}
        lang={lang}
        participantsById={participantsById}
      />
    );
  }
  return (
    <KnockoutBracketView
      bracket={bracket}
      hasEventsPermission={hasEventsPermission}
      onSelectMatch={onSelectMatch}
      lang={lang}
      participantsById={participantsById}
    />
  );
}
